/**
 * Paylaşılan **sayı ekseni** (Reuse Mandate) — {@link StackedBar} satırlarının altına konan yatay ölçek.
 *
 * Bağımsız bir grafik motoru değildir; yalnız çubukların okunmasını sağlayan işaretlerdir. Çubuklarla
 * **aynı** `max` değerini alır; genişlikleri yüzdeyle hizalandığı için işaretler çubuk gövdesiyle birebir
 * örtüşür (çağıran, ekseni çubuklarla aynı sütuna yerleştirmelidir).
 *
 * <p><b>Ölçek "yuvarlak" sayılara oturur:</b> ham `max` (ör. 184) doğrudan kullanılsaydı eksen
 * 0 · 36,8 · 73,6 … gibi okunmaz değerler üretirdi. Bunun yerine 1/2/5×10ⁿ ailesinden bir adım seçilir ve
 * üst sınır o adımın katına yuvarlanır — mockup'taki 0 · 20 · 40 … 200 dizisi böyle çıkar.
 *
 * <p>Eksen `aria-hidden`'dır: taşıdığı bilgi (her satırın sayıları) çağıran tarafında zaten <b>metin</b>
 * olarak bulunur; ekran okuyucuya ölçek işaretlerini tekrar okutmak gürültüdür.
 */
import { axisScale } from '../../lib/axisScale'

export interface BarChartAxisProps {
  /** Çubuklarla **aynı** ölçek tabanı (ham en büyük toplam). */
  max: number
  /** Eksenin altındaki açıklama, ör. "Aksiyon Sayısı". */
  label?: string
  /** Hedeflenen işaret sayısı; verilmezse `axisScale` varsayılanı (10). Gerçek sayı yuvarlamayla oynar. */
  targetTicks?: number
  className?: string
}

export default function BarChartAxis({ max, label, targetTicks, className }: Readonly<BarChartAxisProps>) {
  const { upper, ticks } = axisScale(max, targetTicks)

  return (
    <div className={`ui-axis${className ? ` ${className}` : ''}`} aria-hidden="true">
      <div className="ui-axis-line">
        {ticks.map((tick) => (
          <span key={tick} className="ui-axis-tick" style={{ left: `${(tick / upper) * 100}%` }}>
            {tick}
          </span>
        ))}
      </div>
      {label != null && <div className="ui-axis-label">{label}</div>}
    </div>
  )
}
